module.exports = __webpack_public_path__ + "img/Comedy_club.b10158da.png";